/* System defined core library */
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

/* User defined library/components */
import { SelectedExamDetailService } from '../../../scheduling/shared/services/selected-exam-detail.service';

@Component({
  selector: 'prev-button',
  templateUrl: './prev-button.component.html'
})

export class PrevButtonComponent {

  /* Input-OutPut parameters decalartions */
  @Input() isDisable: boolean = false;
  @Output() onClick: EventEmitter<any> = new EventEmitter<any>();

  translateLanguage$: Subscription;

  /* Constructor declaration with required injected services */
  constructor(
    private selectedExamDetailService: SelectedExamDetailService,
    private translate: TranslateService
  ) {
    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
      });
  }

  /*Emit Click Event */
  submit(event: any) {
    this.onClick.emit(event);
  }

  getClass() {
    let programCode = this.selectedExamDetailService.programCode ? this.selectedExamDetailService.programCode.toLowerCase() : '';

    let clientCode = this.selectedExamDetailService.clientCode ? this.selectedExamDetailService.clientCode.toLowerCase() : '';

    return `btn tempPrevBtn tempPrevBtn-${programCode} tempPrevBtn-${clientCode}`
  }
}
